import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { Button, HeaderSearchBar, IconClose } from 'uikit';

import React, { forwardRef } from 'react';
import { useParams } from 'react-router-dom';

import type { IPriceTabProps } from '../../helpersAndTypes';

import { useTableColumns } from './hooks';

import Styles from './priceTable.module.css';

export const PriceTable = forwardRef((props: IPriceTabProps, tableApiRef: any) => {
    const {
        filters,
        dataSource,
        onSearch,
        onSearchStringChange,
        onSearchStringClear,
        searchString,
        checkedPrices,
        onChangeCheckedPrices,
        extraColumnDefs,
        filterVariables,
        changeFilterHandler,
    } = props;

    const { orderChangeId } = useParams();

    const tableColumns = useTableColumns({
        onChangeCheckedPrices,
        checkedPrices,
        extraColumnDefs,
        filterVariables,
        changeFilterHandler,
        isOrderChange: !!orderChangeId,
    });

    const addingPriceContext = {
        tableUniqueId: 'addingPriceList',
    };

    return (
        <div className={Styles.container}>
            <div className={Styles.searchBlock}>
                <HeaderSearchBar
                    placeholder="Поиск расценки в прейскуранте"
                    label="поиск"
                    value={searchString}
                    onChange={onSearchStringChange}
                    onSearch={onSearch}
                    className={Styles.searchBar}
                />
                {!!searchString?.length && (
                    <Button
                        label="Очистить"
                        view="ghost"
                        iconLeft={IconClose}
                        form="round"
                        size="xs"
                        onlyIcon
                        onClick={onSearchStringClear}
                        className={Styles.searchBarClear}
                    />
                )}
            </div>
            <AgGridTable
                className={Styles.table}
                ref={tableApiRef}
                datasource={dataSource}
                rowModelType="infinite"
                maxConcurrentDatasourceRequests={1}
                maxBlocksInCache={50}
                cacheBlockSize={50}
                columnDefs={tableColumns}
                key={filters.searchString}
                headerHeight={70}
                context={addingPriceContext}
            />
        </div>
    );
});

PriceTable.displayName = 'PriceTable';
